export function getRunnableFeedbackCategory({
  selectedFeedbackCategory,
  hasUserSelectedFeedbackCategory,
}) {
  if (!selectedFeedbackCategory) return null;
  if (!hasUserSelectedFeedbackCategory && selectedFeedbackCategory === "developmental") return null;
  return selectedFeedbackCategory;
}

export function getProjectFeedbackCategoryState({
  projectId,
  projectFeedbackPreferences,
  feedbackCategoryByProjectId,
  selectedFeedbackCategory,
  hasUserSelectedFeedbackCategory,
}) {
  if (!projectId) {
    return {
      selectedFeedbackCategory,
      hasUserSelectedFeedbackCategory,
    };
  }

  const projectCategory = feedbackCategoryByProjectId?.[projectId];
  if (projectCategory?.updatedAt) {
    return {
      selectedFeedbackCategory: projectCategory.selectedFeedbackCategory ?? null,
      hasUserSelectedFeedbackCategory: projectCategory.hasUserSelectedFeedbackCategory === true,
    };
  }

  if (projectFeedbackPreferences) {
    return {
      selectedFeedbackCategory: projectFeedbackPreferences.selectedCategory ?? null,
      hasUserSelectedFeedbackCategory: projectFeedbackPreferences.hasUserSelectedCategory === true,
    };
  }

  return {
    selectedFeedbackCategory: null,
    hasUserSelectedFeedbackCategory: false,
  };
}

export function shouldRequireFeedbackCategorySelection({
  selectedFeedbackCategory,
  hasUserSelectedFeedbackCategory,
}) {
  return !getRunnableFeedbackCategory({
    selectedFeedbackCategory,
    hasUserSelectedFeedbackCategory,
  });
}

export function shouldShowFeedbackCategoryLabel({
  selectedFeedbackCategory,
  hasUserSelectedFeedbackCategory,
}) {
  return Boolean(getRunnableFeedbackCategory({
    selectedFeedbackCategory,
    hasUserSelectedFeedbackCategory,
  }));
}
